enum Actions {
  //Auth
  SIGN_IN = "signIn",
  SIGN_OUT = "signOut",
  VERIFY_AUTH = "verifyAuth",
  //channels
  FETCH_CHANNEL = "fetchChannel",
  FETCH_CHANNEL_SCHEDULES = "fetchChannelSchedules",
  //programs
  FETCH_PROGRAM = "fetchProgram",
}

enum Mutations {
  //Auth
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  //assets
  SET_CHANNEL = "setChannel",
  SET_CHANNEL_SCHEDULES = "setChannelSchedules",
  //programs
  SET_PROGRAM = "setProgram",
}

export { Actions, Mutations };
